import React, { useState } from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings.js'
import { CHECPLUS_MODULE_TYPES, CAN } from 'utils/constants'
import { isNil, isEmpty } from 'ramda'
import Editor from 'components/feature/Editor'
import { Header } from 'components/patterns'

import OutputFormSection from './OutputFormSection'
import OutputControlSection from './OutputControlSection'

import { StyledEditorContent } from './OutputNodeEditor.style'

const { ASAM } = CHECPLUS_MODULE_TYPES

const OutputNodeEditor = ({
  output,
  deleteOutputNode,
  isDeletable,
  featureModuleType,
  updateNumberOfBits,
  resetOutputNode,
  disableDrawerHandler,
  toggleMarkForDeletion,
  setOutputType,
  validOutputQueryUris,
}) => {
  const { markedForDeletion, description } = output || {}

  const [showUnavailableAction, setShowUnavailableAction] = useState(false)
  const handleUpdateNumberOfBits = (event) => {
    const {
      target: { value },
    } = event
    const isNotValidQueryUri = !(
      isNil(validOutputQueryUris) || isEmpty(validOutputQueryUris)
    )
    // isDeletable indicates there are more than one output
    const blockEvent =
      value === 16 &&
      featureModuleType === ASAM &&
      (isDeletable || isNotValidQueryUri)

    if (blockEvent) setShowUnavailableAction(true)
    else updateNumberOfBits(event)
  }

  const handleSetOutputType = (event) => {
    const {
      target: { value },
    } = event
    const blockEvent =
      value === CAN &&
      featureModuleType === ASAM &&
      !isEmpty(validOutputQueryUris)

    if (blockEvent) setShowUnavailableAction(true)
    else setOutputType(event)
  }

  return (
    output && (
      <Editor
        unavailableHeaderText={strings.unavailable_output_text_header}
        unavailableExplanation={strings.unavailable_output_explanation}
        unavailableAction={setShowUnavailableAction}
        showUnavailableAction={showUnavailableAction}
        markedForDeletion={markedForDeletion}
        toggleMarkForDeletion={toggleMarkForDeletion}
        deleteItem={deleteOutputNode}
        clearItem={resetOutputNode}
        deleteHeaderText={strings.delete_item_heading(description)}
        clearHeaderText={strings.clear_item_heading(description)}
        deleteExplanation={strings.delete_output_explanation}
        clearExplanation={strings.clear_output_explanation}
        showDelete={isDeletable}
        className="function-output-box-editor editor"
        disableDrawerHandler={disableDrawerHandler}
      >
        <Header type="h3" className="form-title">
          {output.description}
        </Header>

        <StyledEditorContent>
          <OutputFormSection
            isDeletable={isDeletable}
            featureModuleType={featureModuleType}
            output={output}
            handleSetOutputType={handleSetOutputType}
            handleUpdateNumberOfBits={handleUpdateNumberOfBits}
          />

          <OutputControlSection output={output} />
        </StyledEditorContent>
      </Editor>
    )
  )
}

OutputNodeEditor.propTypes = {
  fnId: PropTypes.string,
  featureModuleType: PropTypes.string.isRequired,
  output: PropTypes.shape({
    description: PropTypes.string,
    markedForDeletion: PropTypes.bool,
  }).isRequired,
  deleteOutputNode: PropTypes.func,
  toggleMarkForDeletion: PropTypes.func,
  validOutputQueryUris: PropTypes.array,
  isDeletable: PropTypes.bool,
  resetOutputNode: PropTypes.func,
  updateNumberOfBits: PropTypes.func,
  disableDrawerHandler: PropTypes.func,
  setOutputType: PropTypes.func,
}

export default OutputNodeEditor
